import React from 'react'


export const MoveIn = () => {
    return <div>MoveIn</div>
}